/*
  <bloom-announcement> — rotating announcement messages. All messages are
  server-rendered; with JS off the first shows (others are visually hidden but
  present for crawlers). Auto-rotates, pauses on hover/focus, arrows for manual
  control, respects prefers-reduced-motion (no auto-rotate).
*/
class BloomAnnouncement extends HTMLElement {
  connectedCallback() {
    this.msgs = Array.from(this.querySelectorAll('.bloom-announcement__msg'));
    if (this.msgs.length < 2) return;
    this.index = 0;
    this.interval = Math.max(3000, parseInt(this.dataset.interval, 10) || 5000);
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const prev = this.querySelector('[data-ann-prev]');
    const next = this.querySelector('[data-ann-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
    if (next) next.addEventListener('click', () => this.go(this.index + 1, true));

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());
    document.addEventListener('visibilitychange', () =>
      document.hidden ? this.pause() : this.play()
    );

    if (!this.reduce) this.play();
  }

  disconnectedCallback() { this.pause(); }

  go(n, manual) {
    const count = this.msgs.length;
    const next = ((n % count) + count) % count;
    this.msgs.forEach((m, i) => {
      m.classList.toggle('is-active', i === next);
      m.classList.toggle('is-prev', i === this.index && i !== next);
    });
    this.index = next;
    if (manual) this.play();
  }

  play() {
    this.pause();
    if (this.reduce) return;
    this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
  }

  pause() { if (this.timer) { window.clearInterval(this.timer); this.timer = null; } }
}

if (!customElements.get('bloom-announcement')) {
  customElements.define('bloom-announcement', BloomAnnouncement);
}
